import { formatPrice } from "FrontendJsAssets/common/format";

const frontendUpdateTotals = Cart.updates.totals;
Cart.updates.totals = (data) => {
    frontendUpdateTotals(data)

    const customTypes = [
        {
            selector: '[data-type="custom-discount"]',
            property: 'discount'
        },
        {
            selector: '[data-type="old-price-total"]',
            property: 'old-price-total'
        }
    ];

    for (const type of customTypes) {
        const cartElements = document.querySelectorAll(`[data-element="cart"]${type.selector}`)
        const value = data[type.property]

        for (const cartElement of cartElements) {
            const elementHolder = cartElement.closest('.js-cart-element-holder')

            if (elementHolder) {
                elementHolder.classList.toggle('hidden', value === 0)
            }

            cartElement.innerHTML = formatPrice(value)
        }
    }
}